import {
    SET_CREATE_IS_VISIBLE,
    CLIENT_UPDATE_STATUS,
    GET_CLIENTS,
    SET_CLIENT_ID,
    REMOVE_CLIENT,
} from './constants';


const defaultState = {
    isVisible: true,
    clientUpdateStatus: null,
    clientsList: [],
    clientId: null,
};

const removeClient = (state, clientId) => {
    const index = state.clientsList.findIndex(client => client.id === clientId);

    if (index >= 0) {
        return {
            ...state,
            clientsList: [
                ...state.clientsList.slice(0, index),
                ...state.clientsList.slice(index + 1),
            ],
        };
    }

    return state;
};

const addClientUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CREATE_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        case CLIENT_UPDATE_STATUS:
            return { ...state, clientUpdateStatus: action.clientUpdateStatus };

        case GET_CLIENTS:
            return { ...state, clientsList: action.clientsList };

        case SET_CLIENT_ID:
            return { ...state, clientId: action.clientId };

        case REMOVE_CLIENT:
            return removeClient(state, action.id);

        default:
            return state;
    }
};

export default addClientUI;



// WEBPACK FOOTER //
// ./src/containers/AddClient/reducer.js